/* 🤖 this file was generated by svg-to-ts*/
export const iconExternalLink: {
  name: 'external_link';
  data: string;
} = {
  name: 'external_link',
  data: `<svg width="16" height="16" xmlns="http://www.w3.org/2000/svg"><path d="M8 2c1.654 0 3 1.346 3 3a1 1 0 11-2 0c0-.552-.449-1-1-1H3c-.551 0-1 .448-1 1v6c0 .552.449 1 1 1h5c.551 0 1-.448 1-1a1 1 0 112 0c0 1.654-1.346 3-3 3H3c-1.654 0-3-1.346-3-3V5c0-1.654 1.346-3 3-3zm4.445 2.168a1.002 1.002 0 011.387.278l2 3c.022.034.033.072.051.108.017.033.034.064.047.1a.995.995 0 010 .693c-.013.035-.03.066-.047.1-.018.036-.029.074-.05.108l-2 3a1 1 0 01-1.665-1.11L13.132 9H8a1 1 0 110-2h5.132l-.964-1.445a1.001 1.001 0 01.277-1.387z"/></svg>`,
};
